import { useTranslation } from "react-i18next";
import { RTL_LANGUAGES } from "@/i18n";

/**
 * Convenience hook used across the app for translations + RTL awareness.
 * Components can read `isRtl` to swap classNames or motion directions
 * once additional languages (e.g., Arabic) are enabled.
 */
export function useLanguage() {
  const { t, i18n } = useTranslation();
  const lng = i18n.resolvedLanguage || i18n.language || "en";
  const isRtl = RTL_LANGUAGES.has(lng);
  return { t, i18n, lng, isRtl, changeLanguage: i18n.changeLanguage.bind(i18n) };
}
